/**
 * Stable CSS class names for E2E — Dynamic JSON template builder (list, add, edit).
 */
export const DJB = {
    page: 'dynamic-json-builder-page',
} as const;

export const DJBL = {
    divider: 'dynamic-json-builder-list-page__divider',
    toolbar: 'dynamic-json-builder-list-page__toolbar',
    actionsPrimary: 'dynamic-json-builder-list-page__actions-primary',
    filtersRow: 'dynamic-json-builder-list-page__filters-row',
    inputButtonCreate: 'dynamic-json-builder-list-input--button-create-template',
    inputSearchKeyword: 'dynamic-json-builder-list-input--textfield-search-keyword',
    inputButtonFilter: 'dynamic-json-builder-list-input--button-filter',
    tableContainer: 'dynamic-json-builder-list-page__table-container',
    table: 'dynamic-json-builder-list-page__table',
    paginationWrap: 'dynamic-json-builder-list-page__pagination-wrap',
    inputButtonPreview: 'dynamic-json-builder-list-input--button-preview',
    inputButtonModifyStructure: 'dynamic-json-builder-list-input--button-modify-structure',
    inputIconRowMenu: 'dynamic-json-builder-list-input--icon-button-row-menu',
} as const;

export const DJBA = {
    divider: 'dynamic-json-builder-add-page__divider',
    shell: 'dynamic-json-builder-add-page__shell',
    paper: 'dynamic-json-builder-add-form',
    body: 'dynamic-json-builder-add-form__body',
    title: 'dynamic-json-builder-add-form__title',
    fieldsGrid: 'dynamic-json-builder-add-form__fields-grid',
    inputTextfieldTemplateName: 'dynamic-json-builder-add-input--textfield-template-name',
    inputTextfieldTemplateKey: 'dynamic-json-builder-add-input--textfield-template-key',
    inputTextfieldTeamName: 'dynamic-json-builder-add-input--textfield-team-name',
    actionsRow: 'dynamic-json-builder-add-form__actions-row',
    inputButtonCancel: 'dynamic-json-builder-add-input--button-cancel',
    inputButtonSave: 'dynamic-json-builder-add-input--button-save',
} as const;

export const DJBE = {
    divider: 'dynamic-json-builder-edit-page__divider',
    shell: 'dynamic-json-builder-edit-page__shell',
    paper: 'dynamic-json-builder-edit-form',
    body: 'dynamic-json-builder-edit-form__body',
    title: 'dynamic-json-builder-edit-form__title',
    fieldsGrid: 'dynamic-json-builder-edit-form__fields-grid',
    inputTextfieldTemplateName: 'dynamic-json-builder-edit-input--textfield-template-name',
    inputTextfieldTemplateKey: 'dynamic-json-builder-edit-input--textfield-template-key',
    inputTextfieldTeamName: 'dynamic-json-builder-edit-input--textfield-team-name',
    actionsGrid: 'dynamic-json-builder-edit-form__actions-grid',
    inputButtonCancel: 'dynamic-json-builder-edit-input--button-cancel',
    inputButtonUpdate: 'dynamic-json-builder-edit-input--button-update',
} as const;

export const djbCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
export const djblCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
export const djbaCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
export const djbeCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
